import { styled } from "@mui/material/styles";

/** Локальный <video> для Shorty — без Shaka/HLS из core/components/Video */
export const ShortyNativeVideo = styled("video")({
  background: "black",
  position: "absolute",
  width: "100%",
  height: "100%",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  objectFit: "cover",
});
